import { DyTableColumn } from 'src/app/dynamic/model/dy-model';

export const TABLE_CONFIG_COLUMNS_TODAY_PATIENT: DyTableColumn[] = [
  {
    dataKey: 'patientName',
    label: 'Patient Name',
    width: 200,
    type: 'text',
  },
  { dataKey: 'patientId', label: 'Patient Id', width: 150, type: 'text' },
  {
    dataKey: 'appointmentDateTime',
    label: 'Appt. Time',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'appointmentStatus',
    label: 'Appt. Status',
    width: 150,
    type: 'status',
  },
  {
    dataKey: 'cellPhone',
    label: 'Contact Number',
    width: 200,
    type: 'phone',
  },
  // { dataKey: 'slot', label: 'Slot', width: 200, type: 'text' },
  {
    dataKey: 'subscriberName',
    label: 'Subscriber Name',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'relationship',
    label: 'Relationship',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'payor',
    label: 'Payor',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'amountDue',
    label: 'Amount Due',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'paymentStatus',
    label: 'Payment Status',
    width: 150,
    type: 'status',
  },
  // {
  //   dataKey: 'status',
  //   label: 'Status',
  //   width: 150,
  //   type: 'status',
  // },
];

export const TABLE_CONFIG_COLUMNS_ALL_PATIENT: DyTableColumn[] = [
  { dataKey: 'patientId', label: 'Patient ID', width: 150, type: 'number' },
  {
    dataKey: 'patientName',
    label: 'Patient Name',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'cellPhone',
    label: 'Contact Number',
    width: 200,
    type: 'phone',
  },
  // { dataKey: 'slot', label: 'Slot', width: 200, type: 'text' },
  {
    dataKey: 'subscriberName',
    label: 'Subscriber Name',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'relationship',
    label: 'Relationship',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'payor',
    label: 'Payor',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'paymentStatus',
    label: 'Payment Status',
    width: 150,
    type: 'status',
  },
  {
    dataKey: 'amountDue',
    label: 'Total Due',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'currentBalance',
    label: '0-30 days',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'thirtyDay',
    label: '31-60 days',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'sixtyDay',
    label: '61-90 days',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'ninetyDay',
    label: '90+ days',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'status',
    label: 'Status',
    width: 150,
    type: 'status',
  },
];
